import axios from 'axios'
import axiosConfig from './modules/axiosConfig'
import PageHome from './pages/Home.js'
import PageDsSections from './pages/ds_sections.js'
import PageLogin from './pages/Login'
import UseMouseOrKeyboard from './modules/UseMouseOrKeyboard'
import DesignSystem from './DesignSystem/DesignSystem'
import { register } from 'swiper/element/bundle'
import logs from './utils/logs'
import ripple from './modules/ripple'
import formErros from './modules/formErros'
import animaAoScroll from './animation/animaAoScroll'
import animateSetup from './animation/animateSetup'


import swiperSobre from './modules/swiperSobre'


import swiperHome from './modules/swiperHome'
import swiperClientes from './modules/swiperClientes'
import swiperCategoriaProjetos from './modules/swiperCategoriaProjetos'
import swiperMidia from './modules/swiperMidia'
import menuHeader from './modules/menuHeader'
import initializePageMidia from './modules/pageMidia';
import initializePageHome from './modules/pageHome';
import { contatoPage } from './pages/contato'


// import SvgUse from "./utils/SvgUse";

// Init
GLOBAL.DesignSystem = DesignSystem({})
register() // Swiper Web Component

// Config
axiosConfig({ csrf: GLOBAL.context?.csrf }, axios)
UseMouseOrKeyboard()
ripple()
formErros()
animateSetup()
animaAoScroll()
console.log('teste')





//NOVOS
swiperSobre()



swiperHome()
swiperClientes()
swiperCategoriaProjetos()
swiperMidia()
menuHeader()
initializePageMidia()
initializePageHome()


// Pages
PageHome()
contatoPage()
PageDsSections()
PageLogin()?.init()

// utils logs
logs()

Fancybox.bind("[data-fancybox]", {
	 
	closeButton:true,
  Carousel: {
		Toolbar: {
      display: {
        left: ["counter"],
        middle: [
       
        ],
        right: ["close"],
      },
    },
    Thumbs: false,
    dragToClose: true,
   
    Image: { zoom: false }
  },
  Zoomable: {
    Panzoom: {
      maxScale: 3,           // zoom máximo
      minScale: 0.5,         // permite zoom in mesmo em imagens pequenas
      clickAction: "zoom",   // clique faz zoom in/out
      pinchToZoom: true,
      wheel: "zoom",
      // contain: "outside"     
    }
  }
});